<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <pageHeader :headerIcon="'weight'"
                :headerText="'Medical Machines'"
                :haveFilterInput="false">
    </pageHeader>

    <div style="padding-top: 25px;">
      <abstractTable  :columns="medicalMachinesColumns"
                      :useData="true"
                      :classes="'ui tablet very compact center aligned celled table'"
                      :paginationEnable="false"
                      :data="computedMedicalMachines()">
        <template slot="table-column">
          <th> {{ $t('actions') }} </th>
        </template>
        <template slot="table-row-after" slot-scope="props">
          <td style="width: 175px">
            <div class="ui icon blue very compact mini button" style="background-color: #092442"
                  :data-tooltip="`${$t('show') + ' ' + $t('log')}`"
                   @click="navigateTo('Show_Medical_Machine', { key: 'params', value: { id: props.row.id } })">
              {{ $t('show') }}
            </div>
          </td>
        </template>
      </abstractTable>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      loading: true,
      medicalMachines: []
    }
  },
  mounted () {
    this.$http.get('medical_machines', {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.medicalMachines = response.data
      this.loading = false
    })
  },
  computed: {
    medicalMachinesColumns () {
      return [
        { fieldName: 'name', header: this.$t('name'), show: true, filterable: false },
        {
          fieldName: 'origin_country',
          header: 'Origin Country',
          show: true,
          filterable: false
        },
        { fieldName: 'location', header: 'Location', show: false, filterable: false },
        { fieldName: 'cost_price', header: 'Cost Price', show: false, filterable: false },
        { fieldName: 'basic_unit_price', header: 'Unit Price', show: true, filterable: false },
        {
          fieldName: 'unit_measurement_name',
          header: 'unit Measurement Name',
          show: true,
          filterable: false
        },
        { fieldName: 'bought_at', header: 'Bought At', show: true, filterable: false },
        { fieldName: 'id', header: this.$t('id'), show: false, filterable: false }
      ]
    }
  },
  methods: {
    computedMedicalMachines () {
      let formaltedMedicalMachines = []

      window._.each(this.medicalMachines, medicalMachine => {
        formaltedMedicalMachines.push({
          id: medicalMachine.id,
          name: medicalMachine.name || '-',
          origin_country: medicalMachine.origin_country || '-',
          location: medicalMachine.location || '-',
          cost_price: medicalMachine.cost_price || '-',
          unit_measurement_name: medicalMachine.unit_measurement ?
            medicalMachine.unit_measurement.name : '-',
          basic_unit_price: medicalMachine.basic_unit_price || '-',
          bought_at: window.moment(medicalMachine.bought_at).format('DD/MM/YYYY hh:mm a')
        })
      })

      return formaltedMedicalMachines
    }
  }
}
</script>
<style scoped>
  .padding-header {
    padding-bottom: 20px;
  }

  .red-cirle {
    background-color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/medical_machines/MedicalMachines.vue